/* tslint:disable */
/* eslint-disable */
export enum BankStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}
